import React, { useState } from 'react';
import { translate } from '../Services/translation';
import { APIProvider } from '@vis.gl/react-google-maps';
import { updatePreferredClickCollectAddress } from '../Actions/PreferredClickCollectAddress.action'
import { useDispatch } from 'react-redux';
import { googleAnalytics } from '../Services/googleAnalytics';
import { useEffect } from 'react';
import ResellerStore from './ResellerContainer/ResellerStore';
import ResellerZipCodeToCoordinates from './ResellerContainer/ResellerZipCodeToCoordinates.js';
import getDistance from 'geolib/es/getDistance';

const StoreList = (props) => {
    const [selectedStore, setSelectedStore] = useState(null);
    const [zipLatLong, setZipLatLong] = useState({});
    const [allAddresses, setAllAddresses] = useState([]);
    const [filteredStores, setFilteredStores] = useState(allAddresses?.filter((store) => Number(store.distance) <= 1000))
    const [visibleStores, setVisibleStores] = useState(3);
    const dispatch = useDispatch();

    useEffect(() => {
      if (props.store != null && props.store) {
        setSelectedStore(props.store.organizationId)
      }
    }, [])

    const loadMoreStores = () => {
      setVisibleStores((prev) => prev + 10);
    }

    useEffect(() => {
      if (props.stores != null && zipLatLong && zipLatLong.latitude && zipLatLong.longitude) {
        props.stores.forEach((store) => {
          if (store.latitude && store.longitude) {
            store.distance = 0;
            store.distance = getDistance(
                { latitude: store.latitude, longitude: store.longitude },
                { latitude: zipLatLong.latitude, longitude: zipLatLong.longitude },
                100
            ) / 1000;
          } else {
            store.distance = null;
          }
      });
        props.stores.sort((a, b) => a.distance - b.distance);        
        setAllAddresses(props.stores);
        setFilteredStores(props.stores?.filter((store) => Number(store.distance) <= 1000));
        setVisibleStores(3);
      } else {
        setVisibleStores(0);
      }
      
    }, [zipLatLong]);
  
    const selectStore = async (e, store) => {
      e.stopPropagation();
      if(store.organizationId !== selectedStore) {
        googleAnalytics({
          'event': 'clickAndCollect',
          'selectStore': store.shopName,
        })        
        setSelectedStore(store.organizationId);
        props.setStore(store)
        dispatch(updatePreferredClickCollectAddress(store));
      } else {
        setSelectedStore(null)
        props.setStore({})
        window.localStorage.removeItem('preferredclickcollectaddress');
      }
    }
        
  return (
    <div className="add-articles storeList">
      <h1 className='storeList__title'>{translate('storelist.title')}</h1>
      <p className='storeList__description'>{translate('brenderup.storelist.description')}</p>
      <APIProvider apiKey={'AIzaSyBasMn4C1xOwCE_YL6nr0pjQGYsT5A3a9A'}>
        <ResellerZipCodeToCoordinates setZipLatLong={setZipLatLong} />
      </APIProvider>
      <div className={`storeList__list ${filteredStores.length > 3 && visibleStores > 3 ? 'storeList__list--scroll' : ''}`}>
        {filteredStores.slice(0, visibleStores).map((store) => (
          <ResellerStore
            key={store.organizationId}
            store={store}
            selectStore={selectStore}
            isSelected={selectedStore === store.organizationId}
          />
        ))}
      </div>
      <div className="storeList__load-more">
        {filteredStores.length > visibleStores && (
          <button onClick={loadMoreStores}>
            {translate('brenderup.storelist.showmore')}
          </button>
        )}
      </div>
    </div>
  )
}

export default StoreList;